import styled from 'styled-components';
import { getColor } from 'core/utils';
import LazyLoadedImg from 'core/components/LazyLoadedImg';

export const Wrapper = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: block;
	padding-bottom: 66.6%;
	background: ${getColor("alto")};
	overflow: hidden;
	border-radius: 8px;

	margin: 16px 0px;

	&:last-child {
		margin-bottom: 0px;
	}
`;

export const Overlay = styled.div`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(255, 255, 255, 0.4);
	cursor: pointer;

	display: flex;
	justify-content: center;
	align-items: center;

	svg {
		width: 47px;
		height: 47px;
	}
`;

export const StyledImg = styled(LazyLoadedImg)`
	position: absolute;
	width: 100%;
	height: 100%;
	object-fit: cover;
`;
